module.exports = __webpack_public_path__ + "img/bornemouth.6bad8ccf.png";